import { List } from "immutable";
import * as M from "../models";

export interface CareerCenterState {
    loadingJobs: boolean;
    loadingResumes: boolean;
    jobs: List<M.CareerCenter.JobPost>;
    resumes: List<M.CareerCenter.Resume>;
    userJobs: List<M.CareerCenter.JobPost>;
    userResumes: List<M.CareerCenter.Resume>;
    userSubscriptions: M.CareerCenter.UserSubscriptions;
}

export const initialState: CareerCenterState = {
    loadingJobs: true,
    loadingResumes: true,
    jobs: List(),
    resumes: List(),
    userJobs: List(),
    userResumes: List(),
    userSubscriptions: {
        jobPostCategoryIds: [],
        resumeCategoryIds: [],
    },
};



// WEBPACK FOOTER //
// ./src/store/CareerCenterState.ts